module.exports = __webpack_public_path__ + "static/media/CarneCuadrada.64ecb4d6.jpg";